export default __webpack_public_path__ + "static/media/walnut.texture.f245dc52.webp";